export default __webpack_public_path__ + "static/media/multi-plataform.a2d81e13.svg";